import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { datesHelper } from "@/shared/utils";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type TerminalsInput,
  terminalsInputSchema,
} from "./shared/terminals.input";
import { type Terminal, terminalSchema } from "./shared/terminals.output";

/**
 * Metadata for the fetchTerminals endpoint
 */
export const terminalsMeta = {
  functionName: "fetchTerminals",
  endpoint: "/terminals/{TripDate}",
  inputSchema: terminalsInputSchema,
  outputSchema: terminalSchema.array(),
  sampleParams: { TripDate: datesHelper.tomorrow() },
  endpointDescription: "List valid departing terminals for a trip date.",
} satisfies EndpointMeta<TerminalsInput, Terminal[]>;

/**
 * Fetch function for retrieving valid departing terminals for a trip date
 */
const { fetch, useHook } = createFetchAndHook<TerminalsInput, Terminal[]>({
  api: wsfScheduleApiMeta,
  endpoint: terminalsMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/terminals.endpoints").scheduleTerminalsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving valid departing terminals for a trip date
 */
export const fetchTerminals: FetchFactory<TerminalsInput, Terminal[]> = fetch;

/**
 * React Query hook for retrieving valid departing terminals for a trip date
 */
export const useTerminals: HookFactory<TerminalsInput, Terminal[]> = useHook;
